import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useBrandKitPageStyle = makeStyles({
  brandKitPage: {
    display: 'flex',
    ...shorthands.margin('32px', '36px'),
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalL),
  },
  brandElements: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalL),
  },
});
